import React from "react";

import { Route, BrowserRouter as Router, Switch } from "react-router-dom";
import Introduction from "../src/components/introduction";
import Projects from "../src/sideComponents/projects";
import Error from "../src/components/Error";
import "./App.css";

function App() {
  const [darkTheme, setDarkTheme] = React.useState(true);
  return (
    <div className={darkTheme ? "dark-theme" : "light-theme"}>
      <nav>
        <button
          id="toggle"
          onClick={() => setDarkTheme((prevTheme) => !prevTheme)}
        >
          {darkTheme ? "Light Theme" : "Dark Theme"}
        </button>
      </nav>
      <Router>
        <div className="App">
          <Switch>
            <Route exact path="/" component={Introduction} />

            <Route exact path="/projects" component={Projects} />
            <Route component={Error} />
          </Switch>
        </div>
      </Router>
    </div>
  );
}

export default App;
